export class indentIdReq {
    indentItemId:number
    constructor(indentItemId:number) {
        this.indentItemId = indentItemId;
    }
}